<template>
  <div class="Language">
    <div class="title">{{title}}</div>
    <div class="langs">
      <div v-for="(l, index) in langs" class="lg"
           @click="select(index)" :class="{selected: selected==index }" >
        <div class="text">{{l}}<br>{{la[index]}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Language',
    data() {
      return {
        selected: 0
      }
    },
    computed: {
      title() {
        return '参赛语言'
      },
      langs() {
        return this.$store.state.enroll.languages
      },
      la() {
        return [
          '(推荐)',
          '',
          '',
          
        ]
      }
    },
    methods: {
      select(index) {
        this.selected = index
        this.$store.commit('updateEnrollLang', this.langs[index])
      },

    },
    mounted(){
      let userInfo = this.$parent.user
    },
    components: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Language{
    width: 62.5vw;
    background-image: url(~@/assets/image/enroll/bg-area.png);
    background-size: 62.5vw;
    box-sizing: border-box;
    color: white;
    font-weight: 500;
    border-radius: 2px;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 2.4vw 3.8vw 2.1vw;
 
 }
  .title{
    color: white;
    font-size: 1.875vw;
    line-height: 1.85vw;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2vw;
  }


 .langs {
   width: 40vw;
   font-size: 28px;
   display: flex;
   justify-content:space-between;

 }
 .lg {
   padding: 5px 8px;
   text-align:center;
   border-radius: 5px;
   text-transform:capitalize;
 }
 .lg.selected {
   background: #62DD95;
 }
</style>
